/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgentJobPayload { 
    payload: object;
    type: AgentJobPayload.TypeEnum;
}
export namespace AgentJobPayload {
    export type TypeEnum = 'PUSH_INVENTORY' | 'PUSH_HEALTH' | 'PUSH_USAGE' | 'RECONFIGURE';
    export const TypeEnum = {
        PUSH_INVENTORY: 'PUSH_INVENTORY' as TypeEnum,
        PUSH_HEALTH: 'PUSH_HEALTH' as TypeEnum,
        PUSH_USAGE: 'PUSH_USAGE' as TypeEnum,
        RECONFIGURE: 'RECONFIGURE' as TypeEnum
    };
}


